export const PRODUCTS = ['Golden Morning', 'Wild Forest', 'River Bloom', 'Seasonal / Other'];
export const VARIETIES = ['Grey Box', 'Messmate', 'River Red Gum', 'Other'];
export const SIZES = ['30 g sample', '370 g', '500 g', 'Squeeze bottle', 'Other'];

const invColumns = [
  { key: 'item', label: 'Item', input: 'text', width: '24%' },
  { key: 'current', label: 'Current', input: 'number', width: '12%' },
  { key: 'min', label: 'Minimum', input: 'number', width: '12%' },
  { key: 'reorder', label: 'Reorder Qty', input: 'text', width: '13%' },
  { key: 'supplier', label: 'Supplier', input: 'text', width: '21%' },
  { key: 'date', label: 'Reorder Date', input: 'date', width: '18%' },
];
const invRows = ['30 g samples', '370 g jars', '500 g jars', 'Squeeze bottles'].map(item => ({ item }));

export const PLANNERS = [
  {
    id: 'daily', num: '01', title: 'Daily Business Planner', desc: 'Top 3, orders, stock, tasks & sales for the day.',
    sections: [
      { type: 'grid', fields: [ { key: 'date', label: 'Date', input: 'date' }, { key: 'day', label: 'Day', input: 'text' } ] },
      { type: 'lines', key: 'top3', title: "Today's Top 3", count: 3 },
      { type: 'area', key: 'orders_pack', title: 'Orders to Pack', rows: 4, half: true },
      { type: 'area', key: 'deliveries', title: 'Deliveries / Orders to Send', rows: 4, half: true },
      { type: 'grid', title: 'Stock Check', fields: [
        { key: 'stock_gm', label: 'Golden Morning', input: 'text' }, { key: 'stock_wf', label: 'Wild Forest', input: 'text' },
        { key: 'stock_rb', label: 'River Bloom', input: 'text' }, { key: 'stock_other', label: 'Other', input: 'text' } ] },
      { type: 'area', key: 'production', title: 'Production / Jar Filling', rows: 3, half: true },
      { type: 'area', key: 'followups', title: 'Stockist Follow-Ups', rows: 3, half: true },
      { type: 'area', key: 'content', title: 'Content Today', rows: 3, half: true },
      { type: 'checklist', key: 'tasks', title: 'Tasks', items: [], allowAdd: true, half: true },
      { type: 'area', key: 'notes', title: 'Notes / Ideas', rows: 4, half: true },
      { type: 'grid', title: 'Sales Today', half: true, fields: [ { key: 'sales_today', label: '$', input: 'number' } ] },
      { type: 'area', key: 'tomorrow', title: "Tomorrow's Priority", rows: 2 },
    ],
  },
  {
    id: 'weekly', num: '02', title: 'Weekly Business Planner', desc: 'Weekly goals, day-by-day plan and review.',
    sections: [
      { type: 'grid', fields: [ { key: 'week', label: 'Week commencing', input: 'date' } ] },
      { type: 'lines', key: 'goals', title: "This Week's Top 3 Goals", count: 3 },
      ...['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'].map(d => (
        { type: 'area', key: d.toLowerCase(), title: d, rows: 2, half: true })),
      { type: 'area', key: 'orders', title: 'Orders', rows: 3, half: true },
      { type: 'area', key: 'production', title: 'Production', rows: 3, half: true },
      { type: 'area', key: 'retailers', title: 'Retailers / Stockists', rows: 3, half: true },
      { type: 'area', key: 'content', title: 'Content to Create', rows: 3, half: true },
      { type: 'area', key: 'markets', title: 'Markets / Events', rows: 3, half: true },
      { type: 'area', key: 'purchasing', title: 'Purchasing / Supplies', rows: 3, half: true },
      { type: 'grid', title: "This Week's Sales", half: true, fields: [ { key: 'week_sales', label: '$', input: 'number' } ] },
      { type: 'area', key: 'went_well', title: 'What Went Well?', rows: 3, half: true },
      { type: 'area', key: 'next_week', title: 'Next Week', rows: 3 },
    ],
  },
  {
    id: 'orders', num: '03', title: 'Orders & Packing', desc: 'Order table with packing checklist.',
    landscapeHint: true,
    sections: [
      { type: 'table', key: 'orders', title: 'Orders', minRows: 6, columns: [
        { key: 'num', label: 'Order #', input: 'text', width: '8%' },
        { key: 'customer', label: 'Customer', input: 'text', width: '13%' },
        { key: 'date', label: 'Date', input: 'date', width: '10%' },
        { key: 'product', label: 'Product', input: 'select', options: PRODUCTS, width: '12%' },
        { key: 'variety', label: 'Variety', input: 'select', options: VARIETIES, width: '10%' },
        { key: 'size', label: 'Size', input: 'select', options: SIZES, width: '9%' },
        { key: 'qty', label: 'Qty', input: 'number', width: '5%' },
        { key: 'packed', label: 'Packed', input: 'check', width: '5%' },
        { key: 'paid', label: 'Paid', input: 'check', width: '5%' },
        { key: 'delivery', label: 'Delivery', input: 'select', options: ['Delivery', 'Pickup'], width: '8%' },
        { key: 'tracking', label: 'Tracking', input: 'text', width: '8%' },
        { key: 'notes', label: 'Notes', input: 'text', width: '7%' } ] },
      { type: 'checklist', key: 'packing', title: 'Packing Checklist', columns: 3,
        items: ['Jar checked', 'Label applied', 'Tamper seal', 'Packaging', 'Thank-you card', 'Ready to dispatch'] },
    ],
  },
  {
    id: 'production', num: '04', title: 'Honey Production', desc: 'Batch sheet with quality check.',
    sections: [
      { type: 'grid', title: 'Batch Details', fields: [
        { key: 'date', label: 'Date', input: 'date' }, { key: 'batch', label: 'Batch Number', input: 'text' },
        { key: 'variety', label: 'Honey Variety', input: 'select', options: PRODUCTS },
        { key: 'supplier', label: 'Supplier / Apiary', input: 'text' }, { key: 'origin', label: 'Origin', input: 'text' },
        { key: 'qty_received', label: 'Quantity Received', input: 'text' }, { key: 'temp', label: 'Temperature', input: 'text' },
        { key: 'date_jarred', label: 'Date Jarred', input: 'date' } ] },
      { type: 'checklist', key: 'jar_size', title: 'Jar Size', columns: 4, items: ['30 g', '370 g', '500 g', 'Other'], half: true },
      { type: 'grid', title: 'Output', half: true, fields: [
        { key: 'jars_produced', label: 'Number of jars produced', input: 'number' },
        { key: 'packaging_used', label: 'Packaging used', input: 'text' },
        { key: 'labels_used', label: 'Labels used', input: 'text' } ] },
      { type: 'area', key: 'batch_notes', title: 'Batch Notes', rows: 3 },
      { type: 'checklist', key: 'quality', title: 'Quality Check', columns: 3,
        items: ['Colour', 'Aroma', 'Texture', 'Crystallisation', 'Jar cleanliness', 'Label alignment', 'Seal'] },
      { type: 'grid', fields: [ { key: 'approved_by', label: 'Approved by', input: 'text' }, { key: 'approved_date', label: 'Date', input: 'date' } ] },
    ],
  },
  {
    id: 'inventory', num: '05', title: 'Stock & Inventory', desc: 'Honey and packaging stock with low-stock alerts.',
    sections: [
      { type: 'table', key: 'inv_gm', title: 'Golden Morning — Grey Box', columns: invColumns, seedRows: invRows, lowStock: true },
      { type: 'table', key: 'inv_wf', title: 'Wild Forest — Messmate', columns: invColumns, seedRows: invRows, lowStock: true },
      { type: 'table', key: 'inv_rb', title: 'River Bloom — River Red Gum', columns: invColumns, seedRows: invRows, lowStock: true },
      { type: 'table', key: 'inv_other', title: 'Other / Seasonal Varieties', columns: invColumns, seedRows: [{ item: '' }], lowStock: true },
      { type: 'table', key: 'inv_packaging', title: 'Packaging', columns: invColumns, lowStock: true,
        seedRows: ['Empty jars', 'Lids', 'Labels', 'Tamper seals', 'Thank-you cards', 'Boxes', 'Tissue', 'Honey dippers'].map(item => ({ item })) },
    ],
  },
  {
    id: 'market', num: '06', title: 'Market & Tasting Day', desc: 'Event planning, packing checklist and sales.',
    sections: [
      { type: 'grid', title: 'Event', fields: [
        { key: 'event', label: 'Event Name', input: 'text' }, { key: 'location', label: 'Location', input: 'text' },
        { key: 'date', label: 'Date', input: 'date' }, { key: 'start', label: 'Start Time', input: 'text' },
        { key: 'finish', label: 'Finish Time', input: 'text' } ] },
      { type: 'table', key: 'honey_take', title: 'Honey to Take', columns: [
        { key: 'variety', label: 'Variety', input: 'text', width: '60%' },
        { key: 'qty', label: 'Quantity', input: 'text', width: '40%' } ],
        seedRows: PRODUCTS.map(v => ({ variety: v })) },
      { type: 'checklist', key: 'packing', title: 'Packing Checklist', columns: 3,
        items: ['Honey', 'Samples', 'Water crackers', 'Sample spoons', 'Napkins', 'Tablecloth', 'Signage', 'Price cards', 'Business cards', 'Bags', 'Boxes', 'Payment terminal', 'Phone charger', 'Water'] },
      { type: 'checklist', key: 'before', title: 'Before Event', columns: 2,
        items: ['Social media post', 'Confirm venue', 'Prepare tasting stock', 'Pack vehicle'] },
      { type: 'grid', title: 'Sales', fields: [
        { key: 'opening', label: 'Opening Stock', input: 'text' }, { key: 'closing', label: 'Closing Stock', input: 'text' },
        { key: 'units', label: 'Units Sold', input: 'number' }, { key: 'revenue', label: 'Revenue $', input: 'number' } ] },
      { type: 'grid', title: 'Customer Feedback', fields: [ { key: 'popular', label: 'Most Popular Variety', input: 'select', options: PRODUCTS } ] },
      { type: 'area', key: 'questions', title: 'Customer Questions', rows: 3, half: true },
      { type: 'area', key: 'leads', title: 'Potential Stockists / Leads', rows: 3, half: true },
      { type: 'area', key: 'worked', title: 'What Worked?', rows: 3, half: true },
      { type: 'area', key: 'change', title: 'What to Change Next Time?', rows: 3, half: true },
    ],
  },
  {
    id: 'wholesale', num: '07', title: 'Wholesale & Stockists', desc: 'Stockist pipeline with follow-up reminders.',
    sections: [
      { type: 'followups', key: 'stockists', title: 'Follow-Up Reminders' },
      { type: 'table', key: 'stockists', title: 'Stockist Tracker', minRows: 5, columns: [
        { key: 'business', label: 'Business', input: 'text', width: '12%' },
        { key: 'contact', label: 'Contact', input: 'text', width: '10%' },
        { key: 'email', label: 'Email', input: 'text', width: '12%' },
        { key: 'phone', label: 'Phone', input: 'text', width: '9%' },
        { key: 'location', label: 'Location', input: 'text', width: '9%' },
        { key: 'contacted', label: 'Contacted', input: 'date', width: '9%' },
        { key: 'samples', label: 'Samples', input: 'check', width: '5%' },
        { key: 'followup', label: 'Follow-up', input: 'date', width: '9%' },
        { key: 'products', label: 'Interested In', input: 'text', width: '9%' },
        { key: 'order', label: 'Order', input: 'text', width: '6%' },
        { key: 'status', label: 'Status', input: 'select', width: '10%',
          options: ['Potential', 'Contacted', 'Sample Sent', 'Follow Up', 'Stockist', 'Not Proceeding'] },
        { key: 'notes', label: 'Notes', input: 'text', width: '10%' } ] },
    ],
  },
  {
    id: 'social', num: '08', title: 'Social Media Planner', desc: 'Content plan with weekly overview.',
    sections: [
      { type: 'socialSummary', key: 'posts', title: 'Weekly Content Overview' },
      { type: 'table', key: 'posts', title: 'Content Plan', minRows: 5, columns: [
        { key: 'date', label: 'Date', input: 'date', width: '10%' },
        { key: 'platform', label: 'Platform', input: 'select', options: ['Instagram', 'Facebook', 'TikTok', 'Other'], width: '10%' },
        { key: 'type', label: 'Content Type', input: 'select', width: '12%',
          options: ['Reel', 'Post', 'Story', 'Educational', 'Behind the Scenes', 'Product', 'Stockist', 'Market', 'Honey Education'] },
        { key: 'topic', label: 'Topic', input: 'text', width: '13%' },
        { key: 'hook', label: 'Hook', input: 'text', width: '13%' },
        { key: 'caption', label: 'Caption', input: 'text', width: '14%' },
        { key: 'media', label: 'Photos / Video', input: 'text', width: '10%' },
        { key: 'cta', label: 'Call to Action', input: 'text', width: '9%' },
        { key: 'status', label: 'Status', input: 'select', options: ['Idea', 'To Create', 'Ready', 'Scheduled', 'Posted'], width: '9%' } ] },
    ],
  },
  {
    id: 'sales', num: '09', title: 'Sales Tracker', desc: 'Log sales with automatic totals by period and variety.',
    sections: [
      { type: 'salesSummary', key: 'sales', title: 'Sales Summary' },
      { type: 'table', key: 'sales', title: 'Sales Log', minRows: 6, columns: [
        { key: 'date', label: 'Date', input: 'date', width: '12%' },
        { key: 'channel', label: 'Channel', input: 'select', options: ['Website', 'Market', 'Stockist', 'Direct', 'Other'], width: '11%' },
        { key: 'product', label: 'Product', input: 'select', options: PRODUCTS, width: '14%' },
        { key: 'variety', label: 'Variety', input: 'select', options: VARIETIES, width: '11%' },
        { key: 'size', label: 'Size', input: 'select', options: SIZES, width: '11%' },
        { key: 'qty', label: 'Qty', input: 'number', width: '7%' },
        { key: 'price', label: 'Unit Price', input: 'number', width: '10%' },
        { key: 'total', label: 'Total', calc: r => ((parseFloat(r.qty) || 0) * (parseFloat(r.price) || 0)), width: '10%' },
        { key: 'payment', label: 'Payment', input: 'select', options: ['Card', 'Cash', 'Bank Transfer', 'PayPal', 'Other'], width: '14%' } ] },
    ],
  },
  {
    id: 'monthly', num: '10', title: 'Monthly Business Overview', desc: 'Monthly goals, results and review.',
    sections: [
      { type: 'grid', fields: [ { key: 'month', label: 'Month', input: 'text' } ] },
      { type: 'lines', key: 'goals', title: 'Goals', count: 3 },
      { type: 'grid', title: 'Results', fields: [
        { key: 'target', label: 'Sales Target $', input: 'number' }, { key: 'actual', label: 'Actual Sales $', input: 'number' },
        { key: 'units', label: 'Units Sold', input: 'number' },
        { key: 'best', label: 'Best Selling Honey', input: 'select', options: PRODUCTS } ] },
      { type: 'area', key: 'stockists', title: 'New Stockists', rows: 3, half: true },
      { type: 'area', key: 'markets', title: 'Markets / Events', rows: 3, half: true },
      { type: 'area', key: 'social', title: 'Social Media', rows: 3, half: true },
      { type: 'area', key: 'production', title: 'Production', rows: 3, half: true },
      { type: 'area', key: 'expenses', title: 'Expenses', rows: 3, half: true },
      { type: 'area', key: 'worked', title: 'What Worked This Month?', rows: 3, half: true },
      { type: 'area', key: 'improve', title: 'What Needs Improvement?', rows: 3 },
      { type: 'lines', key: 'next_top3', title: "Next Month's Top 3 Priorities", count: 3 },
    ],
  },
];
